module.exports = __webpack_public_path__ + "img/emoji_58.a37d283d.png";